import { create } from 'zustand';

export const useAppStore = create((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  
  companies: [],
  setCompanies: (companies) => set({ companies }),
  
  devices: [],
  setDevices: (devices) => set({ devices }),
  
  users: [],
  setUsers: (users) => set({ users }),
  
  depots: [],
  setDepots: (depots) => set({ depots }),
  
  notifications: [],
  setNotifications: (notifications) => set({ notifications }),
  
  auditLogs: [],
  setAuditLogs: (auditLogs) => set({ auditLogs }),
}));
